import React from 'react';
import { QuestionCircleFilled, QuestionCircleOutlined } from '@ant-design/icons';
import { Popover, Tooltip } from 'antd';

export const QuestionMark = (props: any) => {
    return (
        <Tooltip title={props.children}>
            <QuestionCircleOutlined
                className="ml-2"
                style={{ cursor: 'pointer', fontSize: '14px', color: '#D92923' }}
            />
        </Tooltip>
    );
};
